import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
import { UserEventTypeCreationDropdown } from 'features/event_type_creation_dropdown';
import { useLeftNavigationState } from './hooks';
import { AddIcon } from './icons';
import { setOpen as setOpenAction } from './slice';
const wrapperCss = "w1qfdewe";
const wrapperMinimizedCss = "w1d47uiu";

/** During collapse animation: align button to the left so it doesn’t sit centered while the bar shrinks. */
const wrapperCollapsingCss = "wpcekg8";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const menuIsTabletUpCss = "m2116kh";
const menuWideCss = "m1skvdje";
const menuCss = "m1hpbxrr";
const Menu = forwardRef((props, ref) => {
  const {
    wide
  } = props;
  const isTabletUp = useDeviceType('isTabletUp');
  return <ViewportDropdownMenu ref={ref} {...props} className={classNames(menuCss, {
    [menuIsTabletUpCss]: isTabletUp,
    [menuWideCss]: wide
  }, props.className)} />;
});
const buttonTextCss = "b1rgxmkl";
const buttonCircleCss = "bvi2dbi";
const ButtonText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(buttonTextCss, props.className)} />;
});

/**
 * Primary CTA that opens the event type creation dropdown.
 * @param {Object} props
 * @param {boolean} [props.minimized] - When true, show compact circular "+" and center in wrapper.
 * @param {boolean} [props.isCollapsing=false] - When true, apply force-left so the button stays left
 *   during collapse (used only after the button has switched to "+").
 */
export const CreateButton = ({
  minimized,
  isCollapsing = false
}) => {
  const dispatch = useDispatch();
  const [toggle, Dropdown, isOpen, {
    dropdownId
  }] = useDropdown(false, true);
  const leftNavigationState = useLeftNavigationState();
  const isNavMinimized = leftNavigationState === 'phone-collapsed' || leftNavigationState === 'minimized';
  const toggleDropdown = () => {
    dispatch(setOpenAction(false));
    toggle();
  };
  return <Wrapper className={classNames(minimized && wrapperMinimizedCss, isCollapsing && wrapperCollapsingCss)}>
      <Button size="large" wide={!minimized} onClick={toggle} id="home-bar-create-button" aria-label={I18n.t('publisher.action.create_new_event_type')} aria-haspopup="menu" decoration="secondary-outline" aria-expanded={isOpen} aria-controls={dropdownId} data-calendly-label="global-create-button" data-pendo-id="v3-editor-redesign" className={minimized ? buttonCircleCss : undefined} tooltip={{
      text: isNavMinimized ? I18n.t('publisher.action.create') : null,
      placement: 'right'
    }}>
        <AddIcon />
        {!minimized && <ButtonText>
            {I18n.t('publisher.action.create')}
          </ButtonText>}
      </Button>
      <Dropdown>
        <Menu wide aria-labelledby="home-bar-create-button">
          <UserEventTypeCreationDropdown toggleDropdown={toggleDropdown} source="main create button" />
        </Menu>
      </Dropdown>
    </Wrapper>;
};

require("./create_button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./create_button.js");